module.exports = __webpack_public_path__ + "static/media/appointmentsIcon.af837772.png";